'use client';

import { cloneElement, useState, useEffect } from 'react';

import { UiKitModalBase } from '@/fo/ui/kit/modal/base';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';

import { styles } from './UiAuthModalBase.styles';

export interface UiAuthModalBaseProps {
  loginForm: React.ReactElement;
  registrationForm: React.ReactNode;
  forgotPasswordForm: React.ReactNode;
  onTabChange?: (name: 'login' | 'registration') => void;
  /** Вызывается при закрытии модалки (чтобы родитель мог сбросить состояние) */
  onClose?: () => void;
}

export function UiAuthModalBase({
  loginForm,
  registrationForm,
  forgotPasswordForm,
  onClose
}: UiAuthModalBaseProps) {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
    if (!nextOpen) onClose?.();
  };
  const [view, setView] = useState<'tabs' | 'forgotPassword'>('tabs');
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [showInformer, setShowInformer] = useState(false);
  const [activeTab, setActiveTab] = useState<'login' | 'registration'>('login');

  const slots = styles();

  useEffect(() => {
    const unsubscribeOnOpen = utilEventAuthModal.onOpen(() => {
      setOpen(true);
      setView('tabs');
    });
    const unsubscribeOnClose = utilEventAuthModal.onClose(() => setOpen(false));
    const unsubscribeOnShowForgotPassword =
      utilEventAuthModal.onShowForgotPassword(() => setView('forgotPassword'));
    const unsubscribeOnSwitchToLoginTab = utilEventAuthModal.onSwitchToLoginTab(
      () => setActiveTab('login')
    );
    const unsubscribeOnSwitchToRegistrationTab =
      utilEventAuthModal.onSwitchToRegistrationTab(() =>
        setActiveTab('registration')
      );
    const unsubscribeOnShowLogin = utilEventAuthModal.onShowLogin((email) => {
      setForgotPasswordEmail(email || '');
      setView('tabs');

      if (email) {
        setShowInformer(false);
        const timer = setTimeout(() => {
          setShowInformer(true);
        }, 500);
        return () => clearTimeout(timer);
      }
    });

    return () => {
      unsubscribeOnOpen();
      unsubscribeOnClose();
      unsubscribeOnShowForgotPassword();
      unsubscribeOnSwitchToLoginTab();
      unsubscribeOnSwitchToRegistrationTab();
      unsubscribeOnShowLogin();
    };
  }, []);

  useEffect(() => {
    if (showInformer && forgotPasswordEmail) {
      const timer = setTimeout(() => {
        setShowInformer(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [showInformer, forgotPasswordEmail]);

  return (
    <UiKitModalBase
      title=""
      isOpen={open}
      setIsOpen={handleOpenChange}
    >
      {view === 'tabs' && (
        <div className={slots.content()}>
          {activeTab === 'login' &&
            cloneElement(
              loginForm as React.ReactElement<{
                showInformer?: boolean;
                forgotPasswordEmail?: string;
              }>,
              { showInformer, forgotPasswordEmail }
            )}
          {activeTab === 'registration' && registrationForm}
        </div>
      )}
      {view === 'forgotPassword' && (
        <div className={slots.content()}>{forgotPasswordForm}</div>
      )}
    </UiKitModalBase>
  );
}
